import {Component, ViewEncapsulation} from '@angular/core';
import {FormBuilder} from '@angular/forms';
import {UserFormBase} from '../user-form-base/user-form-base.component';
import {User} from '../../../model/user';
import {Route} from '../../../enum/route';
import {map, Observable, startWith} from 'rxjs';

@Component({
    selector: 'app-privacy-policy',
    templateUrl: './privacy-policy.component.html',
    styleUrls: ['../../../../styles/form-input.scss'],
    providers: [{ provide: UserFormBase, useExisting: PrivacyPolicyComponent }],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class PrivacyPolicyComponent extends UserFormBase {
  formGroup = this.fb.group({
    accepted: false,

  });
  Route = Route;
  location = window.location.host + `/${Route.DATAPROTECTION}`;


  constructor(private readonly fb: FormBuilder) {
    super();
  }


  updateUser(user: User): void {
    user.privacyPolicyAccepted = this.formGroup.value.accepted;
  }

  validStatus(): Observable<boolean> {
    return this.formGroup.valueChanges.pipe(
      map(() => this.formGroup.value.accepted), startWith(false));
  }
}
